export const isPdfFile = (fileName?: string) =>
  !!fileName?.trim().toLowerCase().endsWith('.pdf');
